class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("refresh-cart", this.refreshCart.bind(this));
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener("set-mystery-close",this.setMysteryForceClose.bind(this));
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    document.addEventListener('drawer:open', () => {
      this.open();
    });
    document.addEventListener('drawer:close', () => {
      this.close();
    });
    document.addEventListener('drawer:open:refresh', () => {
      this.refreshCart();
      this.open();
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    this.checkIfNoMoreSurprises()
    this.setMysteryClose();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      this.checkIfNoMoreSurprises()
      this.setMysteryClose();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  setMysteryClose() {
    if (
      document.querySelector("cart-drawer").classList.contains("is-empty")
    ) {
      document
        .querySelector("cart-drawer .drawer__upsell-wrapper")
        .setAttribute("data-close", true);
    }
  }
  setMysteryForceClose() {
    document
      .querySelector("cart-drawer .drawer__upsell-wrapper")
      .setAttribute("data-close", true);
  }

  hideMystery() {
    document
      .querySelectorAll("cart-drawer-items .cart-item__link")
      .forEach((item) => {
        let prodHandle = "";
        if (
          item.href.includes("mystery-hoodie") ||
          item.href.includes("mystery-item") ||
          item.href.includes("mystery-tee")
        ) {
          prodHandle = item.getAttribute("href").split("?")[0];
          document.querySelector(`cart-drawer .drawer__upsell div[data-href="${prodHandle}"]`).classList.add('is-in-cart')
        }
      });
      this.setMysteryForceClose();
  }
  changeMysteryText() {
    if (document.querySelector('.drawer__upsell-title')){
      let mysteryText = document.querySelector('.drawer__upsell-title')
      mysteryText.querySelector('h2').innerHTML = 'Unlock More Surprises';
      mysteryText.classList.add('unlock-more')
    }
  }
  checkIfNoMoreSurprises() {
    this.hideMystery()
    let allSurprises = document
    .querySelectorAll("cart-drawer .drawer__upsell-item")
    let allSurprisesInCart = document
    .querySelectorAll("cart-drawer .drawer__upsell-item.is-in-cart")
      if (allSurprises.length === allSurprisesInCart.length){
        allSurprises.forEach((item) => {
          item.classList.remove('is-in-cart');
          this.changeMysteryText()
        })
      }
  }

  refreshCart() {
    fetch(window.routes.cart_url)
      .then((res) => res.text())
      .then((data) => {
        let parsedContent = new DOMParser()
          .parseFromString(data, "text/html")
          .querySelector("cart-drawer");
          let currentDrawer = document.querySelector('cart-drawer')
          let cartDrawerItems = parsedContent.querySelector('.drawer__inner')
        currentDrawer.querySelector(".drawer__inner").innerHTML =
          cartDrawerItems.innerHTML;
          if (currentDrawer.classList.contains('is-empty')){
            currentDrawer.classList.remove('is-empty')
          }
        this.checkIfNoMoreSurprises()
      });
  }

}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
